/** 文件说明
@Author: haibowang
@LastModifyTime: 2021-12-21  13:55:57
@Desc: 万知商务模块--数据状态流
**/
import { queryGetSecCategory, queryCategoryList } from '@/axios/wzmall'

const wzmallStore = {
  state: {
    mainCatory: [], // 主分类列表
    sigleMainCatory: {}, // 主分类选择对象
    firstCatory: [], // 一级分类列表
    secondCatory: [], // 二级分类列表
    sigleFirstCatory: {}, // 一级分类选择对象
    threeCatory: [], // 三级分类列表
    singleSecondCatory: {}, // 二级分类选择对象
    singleThreeCatory: {}, // 三级分类选择对象
    shoppingCarGoods: 0
  },
  mutations: {
    SET_MATERTYPES (state, value) {
      state.mainCatory = value
    },
    SET_FIRSTCATORY (state, value) {
      state.firstCatory = value
    },
    SET_SECONDCATORY (state, value) {
      state.secondCatory = value
    },
    SET_MAINCATORYID (state, value) {
      state.sigleMainCatory = value
    },
    SET_SIGLEFIRSTCATORY (state, value) {
      state.sigleFirstCatory = value
    },
    SET_SIGLESECONDCATORY (state, value) {
      state.singleSecondCatory = value
    },
    SET_THREECATORY (state, value) {
      state.threeCatory = value
    },
    SET_SIGLETHREECATORY (state, value) {
      state.singleThreeCatory = value
    },
    SET_SHOPPINGCARGOODS (state, value) {
      state.shoppingCarGoods = value
    }
  },
  actions: {
    getWZMallHeadCatory ({ commit }, params) { // 查询主分类
      queryGetSecCategory(params).then(res => {
        commit('SET_MATERTYPES', res.data.data)
      })
    },
    getFirstHeadCatory ({ commit }, params) { // 查询一级分类
      queryCategoryList({belong_id: params.menu_id, cid: 0}).then(res => {
        commit('SET_MAINCATORYID', params)
        commit('SET_FIRSTCATORY', res.data.data)
        commit('SET_SECONDCATORY', [])
        commit('SET_SIGLEFIRSTCATORY', {})
        commit('SET_SIGLESECONDCATORY', {})
        commit('SET_THREECATORY', [])
        commit('SET_SIGLETHREECATORY', {})
      })
    },
    getSecondHeadCatory ({ commit }, params) { // 查询二级分类
      queryCategoryList({belong_id: params.belong_id, cid: params.id}).then(res => {
        commit('SET_SECONDCATORY', res.data.data)
        commit('SET_SIGLEFIRSTCATORY', params)
        commit('SET_SIGLESECONDCATORY', {})
        commit('SET_THREECATORY', [])
        commit('SET_SIGLETHREECATORY', {})
      })
    },
    getThreeHeadCatory ({ commit }, params) { // 查询三级分类
      queryCategoryList({belong_id: params.belong_id, cid: params.id}).then(res => {
        commit('SET_THREECATORY', res.data.data)
        commit('SET_SIGLESECONDCATORY', params)
        commit('SET_SIGLETHREECATORY', {})
      })
    }
  }
}

export default wzmallStore



// WEBPACK FOOTER //
// ./src/store/modules/wzmallStoreData.js